var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 10.5L12 5L21 10.5","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18 9V18.1429C18 18.3702 17.9458 18.5882 17.8494 18.7489C17.7529 18.9097 17.6221 19 17.4857 19H6.51429C6.37789 19 6.24708 18.9097 6.15063 18.7489C6.05418 18.5882 6 18.3702 6 18.1429V9","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Home.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Home;

Home.default = Home;
